<template>
  <div class="logistics" v-if="isShowLogistics">
    <v-list-view
      :class="[addressData ? 'top' : 'center']"
      @click="openLogisticsPopup"
      right-icon="arrow-right-v3"
      name="送至"
      v-track="
        trackData.logistic_click({
          sku_id: skuId,
          logistics_status: logisticBuryPointType ? logisticBuryPointType : '5'
        })
      "
    >
      <div class="logistics-row" v-if="addressData">
        <div class="address">
          <span class="address-icon">
            <v-icon class="icon-location" name="icon-location"></v-icon>
          </span>
          <span>{{ addressData.province }}&nbsp;{{ addressData.city }}&nbsp;{{ addressData.area }}&nbsp;</span>
        </div>
        <div :class="preMessage ? 'info-container' : ''">
          <div
            class="info"
            v-if="message"
            v-html="message"
            v-track="
              trackData.logistic_show({
                sku_id: skuId,
                logistics_status: logisticBuryPointType ? logisticBuryPointType : '5',
                address: addressData
              })
            "
          ></div>
        </div>
      </div>
      <div class="logistics-row" v-else>
        <div class="address">
          <span class="address-icon">
            <v-icon class="icon-location" name="icon-location"></v-icon>
          </span>
          <span>&nbsp;点击选择送货地址&nbsp;</span>
        </div>
      </div>
    </v-list-view>
    <v-os-popup
      ref="addressPupop"
      @close="hideAddressPop"
      @footerClick="changeSelect"
      :footerShow="footerShow"
      :footerText="footerText"
      title="配送至"
      v-model="isShowPop"
      container="body"
    >
      <div class="logistics-pop">
        <div class="address-list" v-if="isShowList && getAddressListData.length">
          <address-list
            :message="message"
            :distributionMessage="distributionMessage"
            :delayDesc="delayDesc"
            :addressData="addressData"
            :getAddressListData="getAddressListData"
            :isLaser="selectParams.laser"
            @changeAddress="changeAddress"
            @showDelay="showDelay"
          />
        </div>
      </div>
    </v-os-popup>
    <v-os-popup
      ref="delayPopop"
      @close="delayShow = false"
      title="订单发货延误赔付规则说明"
      v-model="delayShow"
      container="body"
    >
      <div class="delay-desc">{{ delayDesc }}</div>
    </v-os-popup>
    <nx-vmic-address-picker
      v-backFn="{ show: showRegionSelect, closeFn: 'close' }"
      style="z-index: 2000"
      v-model="showRegionSelect"
      :hotCity="hotCity"
      :addressData="getRegionData"
      highlightColor="#F10313"
      :province="currentAdress.province"
      :city="currentAdress.city"
      :district="currentAdress.area"
      :isWebviewFull="true"
      @confirm="selectConfirm"
      data-html2canvas-ignore="true"
    ></nx-vmic-address-picker>
  </div>
</template>

<script>
// 第三方包
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { VmicAddressPicker } from '@vivo/vos-ui'
// 组件
import AddressList from './address-list'

// api
import {
  getTimelinessByAddress,
  getTimelinessByCoordinate,
  getAddressList,
  getPopularCity,
  getaAddressData
} from './api.js'

// 方法
import trackData from './trackData'

// 配置
import { EXPIRE_TIME, LOGISTICS_REG } from './constant.js'

export default {
  name: 'Logistics',
  components: {
    AddressList,
    [VmicAddressPicker.name]: VmicAddressPicker
  },
  props: ['isGroupon'],
  data() {
    return {
      isShowPop: false,
      isShowList: true,
      getRegionData: null,
      getAddressListData: [],
      addressData: null, // 地址
      message: '',
      preMessage: '',
      trackData,
      popupsTtile: '配送至',
      distributionMessage: '', // 配送弹层文案
      delayDesc: '', // 延误说明
      delayShow: false,
      serverAddressList: [], // 返回的地址列表
      logisticBuryPointType: '', //物流时效文案类型
      showRegionSelect: false,
      hotCity: null,
      addressPickerPopupFlag: false
    }
  },
  computed: {
    ...mapState('detailv3', ['skuInfo', 'spuInfo', 'selectParams', 'latitude', 'longitude']),
    ...mapGetters('detailv3', [
      // 商品类型，1：手机 2：配件 3：服务 4：虚拟商品
      'goodsType',
      'extCode',
      'isYX',
      'isGift',
      'discountType',
      'isLottery',
      'isShowLogistics'
    ]),
    currentAdress() {
      return this.addressData || { province: '', city: '', area: '' }
    },
    // 用户维护的地址
    userAddress() {
      return this?.spuInfo?.userAddress
    },
    footerText() {
      let isShowList = this.isShowList
      let addressData = this.addressData
      return isShowList && addressData ? '选择其他地址' : '确定'
    },
    footerShow() {
      return this.footerText == '选择其他地址'
    },
    skuCode() {
      return this.skuInfo.commoditySkuBaseInfo.skuCode
    },
    skuId() {
      return this.skuInfo?.commoditySkuBaseInfo?.skuId
    },
    updateAddressParam() {
      return {
        skuId: this.skuId,
        skuCode: this.skuCode,
        skuCount: this.selectParams.number,
        isLaser: this.selectParams.laser ? 1 : 0
      }
    }
  },
  watch: {
    // 监听触发更新物流时效接口的参数对象
    updateAddressParam: {
      handler(newVal, oldVal) {
        if (
          newVal.skuId != oldVal.skuId ||
          newVal.skuCode != oldVal.skuCode ||
          newVal.skuCount != oldVal.skuCount ||
          newVal.isLaser != oldVal.isLaser
        ) {
          if (this.isShowLogistics) this.getTimeliness()
        }
      }
    }
  },
  async created() {
    this.initPage()
  },
  methods: {
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    ...mapMutations('detailv3', [
      'UPDATE_ADDRESS_ID',
      'UPDATE_ADDRESS_DATA',
      'SET_LOGISTICS_MSG',
      'UPDATE_ADDRESS_NEW_FLAG'
    ]),
    selectConfirm(province, city, area) {
      const addressSelectData = {
        province,
        city,
        area
      }
      this.changeAddress(addressSelectData)
    },
    close() {
      if (!this.addressPickerPopupFlag) {
        this.isShowPop = true
      }
      this.showRegionSelect = false
    },
    // 获取经纬度
    geoLocation() {
      if (this.latitude && this.longitude) {
        this.getTimeliness()
      } else {
        if (!this.message) {
          this.$track({
            cfrom: '179|001|02|077',
            event_id: '179|001|02|077',
            page_name: 1,
            sku_id: this.skuId,
            logistics_status: '5',
            address: ''
          })
        }
      }
    },
    async initPage() {
      if (!this.isShowLogistics) return
      // 查看是否有存储地址
      // 初始化地址展示数据
      this.initAddressData()
    },
    async changeSelect() {
      // 底部是选择其他地址
      if (this.footerShow) {
        // 是否有地址数据
        if (!this.getRegionData) {
          this.getRegionData = await getaAddressData()
        }
        // 是否有热门城市数据
        if (!this.hotCity) {
          this.hotCity = await getPopularCity()
        }
        setTimeout(() => {
          this.showRegionSelect = true
        }, 100)
      }
      // 显示list
      // if (this.isShowList) {
      //   this.isShowList = !this.isShowList
      // } else {F
      //   this.isShowPop = false
      // }
      this.isShowPop = false
    },
    // 更新地址
    changeAddress(addressSelectData) {
      addressSelectData.isSwitchAddresses = 1 // 添加手动切换标识，用于页面刷新场景
      this['UPDATE_ADDRESS_DATA'](addressSelectData)
      this.isShowPop = false
      this.isShowList = true
      // 之前是addressSelectData.isFromServer，现在接口改为物流时效打开请求，修改为addressSelectData.id
      if (!addressSelectData.id) {
        this.updateCahe(addressSelectData)
      } else {
        this['UPDATE_ADDRESS_ID'](addressSelectData.id)
        this.addressData = addressSelectData
        this.getTimeliness()
        this['UPDATE_ADDRESS_NEW_FLAG'](1)
      }
    },
    // 更新缓存
    updateCahe(addressSelectData) {
      this.$ls.set('addressData', addressSelectData, EXPIRE_TIME)
      const cacheData = this.$ls.get('addressData')
      this.addressData = cacheData
      const flag = this.getAddressListData.some(item => item.isFromServer !== true)
      if (flag) {
        this.getAddressListData.pop()
        this.getAddressListData = this.getAddressListData.concat(cacheData)
      } else this.getAddressListData = this.getAddressListData.concat(cacheData)
      this.getTimeliness()
      this.checkIsInnerAddress(cacheData)
    },
    // 初始化地址数据
    initAddressData() {
      let cacheData = this.$ls.get('addressData')
      let userAddress = this.userAddress
      // 是否缓存地址
      if (cacheData) {
        this['UPDATE_ADDRESS_DATA'](cacheData)
        this.addressData = cacheData
        this.getTimeliness()
        // 是否有默认维护地址
      } else if (userAddress) {
        this.addressData = {
          ...userAddress,
          isFromServer: true
        }
        this['UPDATE_ADDRESS_DATA'](userAddress)
        this['UPDATE_ADDRESS_ID'](userAddress.id)
        // 维护的送至信息
        const message = this.skuInfo?.logisticTime?.message || ''
        this.message = message.replace(LOGISTICS_REG, "<span style='color:#E90F23;'>$1</span>")
        this.preMessage = this.message
        this.getTimeliness()
      } else {
        this.geoLocation()
      }
    },
    // 初始化物流时效
    getTimeliness() {
      const { province, city, area, detailAddress } = this.addressData || {}
      let longitude = this.longitude
      let latitude = this.latitude
      const { skuId, skuCode } = this.skuInfo.commoditySkuBaseInfo
      const { number, laser } = this.selectParams
      // 地址数据
      let addressParam = {
        province,
        city,
        district: area,
        skuId,
        skuCode,
        detail: detailAddress || '',
        skuCount: number,
        isLaser: laser ? 1 : 0
      }
      // 坐标数据
      let coordinateParam = {
        longitude,
        latitude,
        skuId,
        skuCode,
        skuCount: number,
        isLaser: laser ? 1 : 0
      }
      if (this.discountType === 'vip') {
        addressParam.channel = this.discountType
        coordinateParam.channel = this.discountType
      }
      // 手机和配件，入参增加commodityType，服务端区分是否增加“发货晚必赔”
      if (this.goodsType == 1 || this.goodsType == 2) {
        addressParam.commodityType = this.goodsType
        coordinateParam.commodityType = this.goodsType
      }
      if (province) this.getTimelinessByAddress(addressParam)
      else {
        this.getTimelinessByCoordinate(coordinateParam)
      }
    },
    // 地址查询物流时效
    getTimelinessByAddress(addressParam) {
      this.message = ''
      getTimelinessByAddress(addressParam).then(res => {
        const msg = res?.message?.replace(LOGISTICS_REG, '$1')
        if (msg) this['SET_LOGISTICS_MSG'](msg)
        this.message = res?.message?.replace(LOGISTICS_REG, "<span style='color:#E90F23;'>$1</span>")
        this.preMessage = this.message
        this.distributionMessage = res?.distributionMessage?.replace(LOGISTICS_REG, '$1') || ''
        this.logisticBuryPointType = res?.logisticBuryPointType || ''
        this.delayDesc = res?.delayDesc || ''
        // 对于无物流时效文案时手动上报无物流时效曝光埋点
        if (!this.message) {
          this.$track({
            cfrom: '179|001|02|077',
            event_id: '179|001|02|077',
            page_name: 1,
            sku_id: this.skuId,
            logistics_status: '5',
            address: this.addressData
              ? `${this.addressData.province},${this.addressData.city},${this.addressData.area},${this.addressData?.detailAddress}`
              : ''
          })
        }
      })
    },
    // 坐标查询物流时效
    getTimelinessByCoordinate(coordinateParam) {
      this.message = ''
      getTimelinessByCoordinate(coordinateParam).then(res => {
        const { logisticTime, userAddress } = res
        const msg = logisticTime?.message?.replace(LOGISTICS_REG, '$1')
        if (msg) this['SET_LOGISTICS_MSG'](msg)
        this.message = logisticTime?.message?.replace(LOGISTICS_REG, "<span style='color:#E90F23;'>$1</span>")
        this.preMessage = this.message
        this.distributionMessage = logisticTime?.distributionMessage?.replace(LOGISTICS_REG, '$1') || ''
        this.delayDesc = logisticTime?.delayDesc || ''
        this.logisticBuryPointType = logisticTime?.logisticBuryPointType || ''
        this.addressData = userAddress
        if (userAddress) {
          let param = { ...userAddress, isFromPosition: true }
          this.getAddressListData = this.getAddressListData.concat(param)
          this['UPDATE_ADDRESS_DATA'](param)
        }
        // 对于无物流时效文案时手动上报无物流时效曝光埋点
        if (!this.message) {
          this.$track({
            cfrom: '179|001|02|077',
            event_id: '179|001|02|077',
            page_name: 1,
            sku_id: this.skuId,
            logistics_status: '5',
            address: ''
          })
        }
      })
    },
    async getAddressList() {
      const cacheData = this.$ls.get('addressData') || []
      // 处理是否登录对物流时效的影响
      try {
        const res = await getAddressList()
        this.getAddressListData = res
        this.serverAddressList = res
        this.getAddressListData.forEach(item => {
          item.isFromServer = true
        })
        this.getAddressListData = this.getAddressListData.concat(cacheData)
        if (this.getAddressListData.length) this.isShowList = true
        this.checkIsInnerAddress(cacheData)
      } catch (error) {
        if (error.code == 600) {
          if (cacheData?.province) {
            const flag = this.getAddressListData.some(item => item.isFromServer !== true)
            if (flag) {
              this.getAddressListData.pop()
              this.getAddressListData = this.getAddressListData.concat(cacheData)
            } else this.getAddressListData = this.getAddressListData.concat(cacheData)
            this.isShowList = true
          } else this.isShowList = false
        }
      }
    },
    openLogisticsPopup(e) {
      this.savePreFocusElByEvent(e)
      this.openLogistics()
    },
    // 物流时效逻辑
    async openLogistics() {
      let list = this.getAddressListData.filter(el => {
        return el.id
      })
      if (!list?.length) {
        await this.getAddressList()
      }
      // this.value = true
      // 直接展示地址选择弹层
      if (!this.isShowList || this.getAddressListData.length < 1) {
        // 是否有热门城市数据
        if (!this.hotCity) {
          this.hotCity = await getPopularCity()
        }
        // 是否有地址数据
        if (!this.getRegionData) {
          this.getRegionData = await getaAddressData()
        }
        this.addressPickerPopupFlag = true
        // this.isShowPop = true
        setTimeout(() => {
          this.showRegionSelect = true
        }, 100)
      } else {
        this.isShowPop = true
        this.addressPickerPopupFlag = false
      }
    },
    // 展示发货延误赔付
    showDelay() {
      if (this.delayDesc) {
        this.delayShow = true
      }
    },
    hideAddressPop() {
      this.isShowPop = false
      this.isShowList = true
    },
    // 判断所选城市是否在getAddressListData存在同地区
    checkIsInnerAddress(target) {
      // 未登陆或地址为空，进入结算页校验
      if ((this.serverAddressList || []).length <= 0) {
        return
      }
      const matchedAddress = this.serverAddressList.some(address => {
        return (
          address.isFromServer &&
          address['province'] === target['province'] &&
          address['city'] === target['city'] &&
          address['area'] === target['area']
        )
      })
      this['UPDATE_ADDRESS_NEW_FLAG'](matchedAddress ? 1 : 0)
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .logistics .logistics-row .address .address-icon {
    line-height: 24px !important;
  }
}
</style>
